import { keysToSnake } from '#/api/adapters/wireCase';

function emptyToNull(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

/**
 * PATCH 維修品項：僅 `remark`＋`updatedAt`。
 * 禁送 id／serialNo／產品／問題／accessories／status／簽收鎖定欄。
 */
export function toRepairItemUpdateBody(values = {}) {
  const updatedAt = values.updatedAt ?? values.record?.updatedAt ?? null;
  const body = {
    remark: emptyToNull(values.remark),
  };
  if (updatedAt != null && updatedAt !== '') {
    body.updatedAt = updatedAt;
  }
  return body;
}

export function serializeRepairItemUpdate(values) {
  return keysToSnake(toRepairItemUpdateBody(values));
}
